import { isValid, parseISO } from 'date-fns';

import { DateRangeField } from '@rover/types/src/datetime/DateRange';
import getQueryParams from '@rover/utilities/getQueryParams';

const getStartDateFromQueryParams = (): DateRangeField => {
  const dateStr = (getQueryParams().start_date as string | undefined) ?? '';
  const parsedDate = parseISO(dateStr);
  if (isValid(parsedDate)) {
    return parsedDate;
  }
  return null;
};

export default getStartDateFromQueryParams;
